import { User } from '~/types';
import { is } from './is';

export const can = (user: User, permission: string): boolean =>
  is(user, 'admin') || Boolean(user.permissions?.[permission]);
